import React, { useState } from 'react';

interface FooterProps {
  scrollToSection: (id: string) => void;
}

export default function Footer({ scrollToSection }: FooterProps) {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Newsletter functionality would be implemented here
    alert('Thank you for subscribing!');
    setEmail('');
  };

  return (
    <footer className="bg-[#1A3A2E] text-white">
      <div className="max-w-7xl mx-auto px-20 py-20">
        <div className="grid grid-cols-3 gap-16 mb-20">
          {/* Brand Column */}
          <div>
            <button 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/a9c8693f09f8b92c748c8dc77e0b8d5b.jpeg" 
                alt="Author Logo" 
                className="h-16 w-16 rounded-full object-cover mb-6"
              />
            </button>
            <p className="text-sm text-gray-300 leading-relaxed">
              Crafting stories that resonate<br />
              across generations and<br />
              touch the human soul
            </p>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-400 mb-6">STAY UPDATED</h4>
            <form onSubmit={handleNewsletterSubmit} className="mb-4">
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="w-full bg-transparent border-b border-gray-400 pb-3 text-sm text-white placeholder-gray-400 focus:outline-none focus:border-[#C9A961] transition-colors"
                />
                <button 
                  type="submit"
                  className="absolute right-0 bottom-3 text-[#C9A961] hover:text-[#C9A961]/80 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </div>
            </form>
            <p className="text-xs text-gray-400">
              By subscribing, you agree to our <a href="#" className="underline hover:text-[#C9A961] cursor-pointer">Privacy Policy</a>
            </p>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-400 mb-6">EXPLORE</h4>
            <div className="space-y-5">
              <button 
                onClick={() => scrollToSection('works')}
                className="block text-[#E8DCC4] text-base hover:text-[#C9A961] transition-colors cursor-pointer whitespace-nowrap"
              >
                All Books
              </button>
              <button 
                onClick={() => scrollToSection('updates')}
                className="block text-[#E8DCC4] text-base hover:text-[#C9A961] transition-colors cursor-pointer whitespace-nowrap"
              >
                Book Clubs
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="block text-[#E8DCC4] text-base hover:text-[#C9A961] transition-colors cursor-pointer whitespace-nowrap"
              >
                Press Kit
              </button>
            </div>
          </div>
        </div>

        {/* Brand Statement */}
        <div className="mb-12">
          <h2 className="text-[140px] font-bold text-[#E8DCC4] leading-none tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            LITERARY
          </h2>
        </div>

        {/* Bottom Legal */}
        <div className="pt-8 border-t border-gray-600 text-center">
          <p className="text-xs text-gray-400">
            © 2025 Richard Pontefract. All rights reserved. | <a href="#" className="hover:text-[#C9A961] cursor-pointer">Privacy Policy</a> | <a href="#" className="hover:text-[#C9A961] cursor-pointer">Terms of Service</a> | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A961] cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
